// extracted by mini-css-extract-plugin
module.exports = {"textareaWrapper":"TextArea_textareaWrapper__exx4J","invalid":"TextArea_invalid__M_pkH","readOnly":"TextArea_readOnly__o4oep","textarea":"TextArea_textarea__sjqDw"};